import { FacetModel } from "./../models/facet";
import Marionette from "../../shared/marionette-mustache";
import { backboneViewProperties } from "../../decorators/backbone-properties";

const template = require<string>("../../search/views/category-filter.html");

@backboneViewProperties({
    tagName: "li",
    template: template,
    className: "js-category-option"
})
export class CategoryFilterView extends Marionette.ItemView<FacetModel> {
    public model: FacetModel;
    constructor(options) {
        super(options);
        this.listenTo(this.model, "change:Ticked", this.tickedChanged);
    }

    public onShow() {
        this.tickedChanged();
    }

    public tickedChanged() {
        this.$(`input`).prop("checked", this.model.Ticked);
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click .js-category-option-box"] = (e) => this.checkboxClicked(e);
        return events;
    }

    public checkboxClicked(e: JQueryMouseEventObject) {
        if ($(e.currentTarget).hasClass("disabled") || $(e.currentTarget).parentsUntil("categories-filter").hasClass("disabled") || $(e.currentTarget).parent().hasClass("disabled")) {
            e.stopPropagation();
            e.preventDefault();
            return false;
        }

        this.model.Ticked = !this.model.Ticked;
        this.model.searchModel.filterChangedReRunSearch();

    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/category-filter.ts